<template>
	<div>
		<div style="width: 340px;height: 420px;margin-top: 160px;
			margin-left: auto;margin-right: auto; border-radius: 10px;background-color: #fff;">
			<div style="height: 100px;line-height: 100px;display: flex;justify-content: center;align-items: center;">
				<span >{{ title }}</span>
			</div>	
			<el-form style="padding-left: 40px;padding-right: 40px;">
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-lock" type="password" autofocus placeholder="请输入原密码" v-model="formdata.oldpwd"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-lock" type="password" :show-password="true" placeholder="请输入新密码" v-model="formdata.newpwd"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-lock" type="password" :show-password="true" placeholder="再次输入新密码" v-model="formdata.secondnewpwd"></el-input>
				</el-form-item>
				<el-form-item >
					<el-row>
						<el-col :span="12">
							 <el-input clearable prefix-icon="el-icon-warning" placeholder="短信验证码" v-model="formdata.smscode"></el-input>
						</el-col>
						<el-col :span="12">
							<el-button style="width: 100%;" type="primary" :disabled="smsdisable" @click="sendSms">{{smsbtnword}}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item >
				   <el-button style="width: 100%;" type="primary" @click="submitForgot">修改密码</el-button>
				</el-form-item>
			</el-form>
				
		</div>	
		<div style="position: absolute;bottom: 0px;margin-bottom: 20px;color: #7EA8EB;
			text-align: center;width: 99%;font-size: 12px;">
			<div style="">
				Copyright @ 2024-2099 Sinowyde. All Right Reserved.
			</div>
			<div style="">
				@ 2024-2099 版权所有 宇衡金凯 |
			</div>
		</div>
	</div>
</template>

<script>
	import {userChangePwd,getSmsCodeChange} from '/static/apiUrl.js'
	export default {
		name : 'ChangePassword',
		data() {
			return {
				smsbtnword : '发送验证码',
				countdown : 60,
				smsdisable : false,
				//leftlogourl : "@/assets/images/yh-logo-1.png",
				title : '修改密码',
				formdata : {
					oldpwd : '',
					newpwd : '',
					secondnewpwd : '',
					smscode : '',
				},
				
			}
		},
		mounted() {
			console.log('333')
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		methods: {
			submitForgot(){
				if(this.formdata.oldpwd === null || this.formdata.oldpwd == ''){
					this.$message({
						showClose: true,
						message: '请输入旧密码',
						type: 'error'
					});
					return;
				}else{
					this.formdata.oldpwd = this.$md5(this.formdata.oldpwd)
				}
				if(this.formdata.newpwd === null || this.formdata.newpwd == ''){
					this.$message({
						showClose: true,
						message: '请输入新密码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.secondnewpwd === null || this.formdata.secondnewpwd == ''){
					this.$message({
						showClose: true,
						message: '请再次输入新密码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.smscode === null || this.formdata.smscode == ''){
					this.$message({
						showClose: true,
						message: '请输入短信验证码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.secondnewpwd != this.formdata.newpwd){
					this.$message({
						showClose: true,
						message: '两次输入的新密码不一致',
						type: 'error'
					});
					return;
				}
				// var reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,18}$/;
				// if (!reg.test(this.formdata.newpwd)) {
				// 	this.$message({
				// 		showClose: true,
				// 		message: '密码必须为6-18位大写字母、小写字母、数字、特殊符号中的3种及以上组合',
				// 		type: 'error'
				// 	});
				// 	return false;
				// }
				this.formdata.newpwd = this.$md5(this.formdata.newpwd)
				userChangePwd({
					old_password: this.formdata.oldpwd,
					new_password: this.formdata.newpwd,
					smscode: this.formdata.smscode,
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.$message({
							showClose: true,
							message: '修改密码成功',
							type: 'success'
						});
						let pthis = this
						setTimeout(() => {
							pthis.$router.push({ name: 'noAuth401' });
						}, 1500)
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error'
						});
					}
				})
			},
			sendSms(){
				//发送短信验证码
				this.GetSmsCode("change")

				this.smsdisable = true
				this.smsbtnword = '60s后重试'
				let pthis = this
				let timeout = setInterval(()=>{
					pthis.countdown--
					if(pthis.countdown == 0){
						clearInterval(timeout)
						pthis.smsdisable = false
						pthis.smsbtnword = '发送验证码'
						pthis.countdown = 60
					}else{
						pthis.smsbtnword = pthis.countdown + 's后重试'
					}
				},1000)
				
			},
			GetSmsCode(type){
				getSmsCodeChange({
					type: type,
				}).then(res => {
					if (0 == res.code) {
						console.log("")
					}
				})
			},
		},
		beforeCreate () {
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		beforeDestroy () {
			document.querySelector('body').setAttribute('style', 'background-color:#FFF')
		},
	}
</script>

<style>
	
</style>